import { CommonModule } from '@angular/common';
import { Component, EventEmitter, OnInit, Output, inject } from '@angular/core';
import { FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { finalize } from 'rxjs';
import { InputUserNameHelper } from '@features/auth/shared/helpers/display-email-error.helper';
import { ForgotPasswordService } from '@features/auth/core/domain/forgot-password/forgot-password.service';
import { TranslocoModule } from '@ngneat/transloco';
import { ForgotPasswordFormService } from '../../forgot-password.form.service';
import { IFormNagivation } from '../../forgot-password.interface';
import { ZaaAutofocusDirective } from '@shared/directives/zaa-autofocus/zaa-autofocus.directive';
import { CoreAuthConfigService } from '@features/auth/core-auth-config.service';
import { ACCOUNT_TYPES } from '@features/auth/const';
import { InputAppComponent } from '@features/auth/shared/components/input-app/input-app.component';
import { StorageHelper } from '@features/auth/shared/helpers/storage.helper';

@Component({
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    TranslocoModule,
    ZaaAutofocusDirective,
    InputAppComponent,
  ],
  selector: 'app-input-username',
  templateUrl: './input-username.component.html',
})
export class InputUsernameComponent implements OnInit, IFormNagivation {
  @Output() dataEvent = new EventEmitter<string>();
  // Form service
  formService = inject(ForgotPasswordFormService);
  form = this.formService.form;
  private conf = inject(CoreAuthConfigService);

  // Api service
  public service = inject(ForgotPasswordService);

  public displayErrorMessage = '';
  public showSpinner = false;
  public ENABLE_CHOOSE_ACCOUNT_TYPE =
    this.conf.defaultAuthConfig.typeAccount?.enable;

  public USE_DEFAULT_CHOOSE_ACCOUNT_TYPE =
    this.conf.defaultAuthConfig.typeAccount?.useDefault;

  public TYPES_CHOOSE_ACCOUNT_TYPE =
    this.conf.defaultAuthConfig.typeAccount?.types;

  public ACCOUNT_TYPES: Array<any> = ACCOUNT_TYPES;

  ngOnInit() {
    if (this.USE_DEFAULT_CHOOSE_ACCOUNT_TYPE === false) {
      this.ACCOUNT_TYPES = this.TYPES_CHOOSE_ACCOUNT_TYPE
        ? this.TYPES_CHOOSE_ACCOUNT_TYPE
        : this.ACCOUNT_TYPES;

      const typeAccountControl = this.form.get('typeAccount');

      if (typeAccountControl) {
        // Thêm Validators.required nếu chưa có
        const currentValidators = typeAccountControl.validator ? [typeAccountControl.validator] : [];
        typeAccountControl.setValidators([...currentValidators, Validators.required]);
        typeAccountControl.updateValueAndValidity();
      }
    }
  }


  goBack(): void {
    this.formService.goToLogin();
  }
  next(): void {
    this.getHintEmail();
  }

  getHintEmail() {
    this.displayErrorMessage = '';
    this.dataEvent.emit(this.displayErrorMessage);
    const userNameForm = this.form.get('username');
    const appKeyForm = this.form.get('typeAccount');

    // Validate
    if (userNameForm?.hasError('pattern')) {
      this.displayErrorMessage =
        InputUserNameHelper.displayError('wrongFormat');
      return;
    }
    if (userNameForm?.hasError('required')) {
      this.displayErrorMessage = InputUserNameHelper.displayError('empty');
      return;
    }
    if (appKeyForm?.hasError('required')) {
      this.displayErrorMessage = InputUserNameHelper.displayError('appKeyEmpty');
      return;
    }

    if (userNameForm?.invalid) {
      return;
    }

    // Request
    this.showSpinner = true;
    this.form.disable();

    const { username, typeAccount } = this.form.getRawValue();
    if (typeAccount) {
      StorageHelper.setAppKey(typeAccount);
    }

    this.service
      .getHintEmail(username ?? '')
      .pipe(
        finalize(() => {
          this.form.enable();
          this.showSpinner = false;
        })
      )
      .subscribe({
        next: (value) => {
          this.formService.emailHintDisplay = value;
          this.formService.goToInputEmail();
        },
        error: (err) => {
          console.error(err);
          this.displayErrorMessage = err.message;
          this.dataEvent.emit(this.displayErrorMessage);
        },
      });
  }
}
